import { useTranslations } from '@aikoa/i18n/react'
import { useRouter } from 'expo-router'
import { BoxActionsHeader } from '~/components/layout/ContentBox'
import { SectionTitle } from '~/components/layout/Sections'
import { useUserProfile } from '~/data/user/userProfile'
import { supabase } from '~/lib/supabase'

export function ProfileHeader() {
  const { data: profile } = useUserProfile()
  const isRealtor = profile?.roles?.includes('realtor') || false
  const { t } = useTranslations('user')

  const router = useRouter()

  return (
    <BoxActionsHeader
      contentClassName="border-b-0 pb-0"
      variant="default"
      contextMenuActions={[
        {
          key: 'logout',
          label: t(($) => $.profile.header.logout),
          onPress: async () => {
            try {
              await supabase.auth.signOut({
                scope: 'local',
              })
            } catch (error) {
              console.error('error signing out', error)
            }

            router.replace('/login')
          },
          icon: 'log-out-outline',
          labelClassName: 'text-destructive group-hover/button:text-destructive-foreground',
          iconClassName: 'text-destructive group-hover/button:text-destructive-foreground',
        },
      ]}>
      <SectionTitle>
        {isRealtor
          ? t(($) => $.profile.header.realtorProfile)
          : t(($) => $.profile.header.contactInfo)}
      </SectionTitle>
    </BoxActionsHeader>
  )
}
